<template>
    <div class="layout">
        <div class="layout__header">
            <div class="layout__title">
                <h3>{{ $t('message.damages') }}</h3>
            </div>
            <div class="layout__controls">
                <form :action="action" method="POST" enctype="multipart/form-data">
                    <input type="hidden" name="_token" id="csrf-token" :value="token">
                    <div class="form-inline">
                        <div class="form-field">
                            <input type="file" name="file" id="file">
                        </div>
                        <div class="form-field">
                            <button class="btn-success" type="submit"><i class="fa fa-file-excel-o"></i><span>{{ $t('message.importar') }}</span></button>
                        </div>
                    </div>
                </form>
            </div>
        </div>
        <div class="card">
            <div class="card__content">
                <div class="row">
                    <div class="col-xs-12">
                        <k-table 
                            :exportable="exportable"
                            :mostrarTodos="false"
                            @editar="editar"
                            @eliminar="eliminar"
                            @crear="crear"
                            :columns="columns"
                            :path="path"
                            ref="listaReparaciones"
                            :deleteButton="deleteButton && permiteEliminar" 
                            :createButton="permiteCrear" 
                            :editButton="editButton && permiteEditar"></k-table>
                    </div>
                </div>
            </div>
        </div>
        <modal :clickToClose="false" name="reparacion" width="60%" height="auto" scrollable>
            <reparacion :damage="damage" :reparation="reparation" :title="title"  @saved="saved" @cancelar="cancelar" v-model="selectedItem"></reparacion>
        </modal>
    </div>
</template>

<script>
export default {
    props : {
        action : {
            type : String,
            required : true
        },
        token : {
            type : String,
            required : true
        },
        permiteCrear : {
            type : Boolean,
            required : false, 
            default : true
        },
        permiteEditar : {
            type : Boolean, 
            required : false, 
            default : true
        },
        permiteEliminar : {
            type : Boolean, 
            required : false, 
            default : true
        },
        exportable : {
            type : Boolean,
            required : false,
            default : true
        },
        tituloFormulario : {
            type : String,
            required : false,
            default : 'Daños'
        },
        descripcionFormulario : {
            type : String,
            required : false,
            default : 'Lista de daños'
        },
        title : {
            type : String,
            required : false,
            default : 'Daño'
        },
        createButton : {
            required : false,
            default : true,
            type : Boolean
        },
        editButton : {
            required : false,
            default : true,
            type : Boolean
        },
        deleteButton : {
            required : false,
            default : true,
            type : Boolean
        },
        path : {
            type : String,
            required : false, 
            default : url + '/reparaciones'
        },
        codigoText : {
            type : String,
            required : false,
            default : 'Código'
        },
        descripcionText : {
            type : String,
            required : false,
            default : 'Descripción'
        },
        tipoText : {
            type : String,
            required : false,
            default : 'Tipo'
        },
        creacionText : {
            type : String,
            required : false,
            default : 'Creación'
        },
        modificacionText : {
            type : String,
            required : false,
            default : 'Modificación'
        },
        columns : {
            type : Array,
            required : false,
            default : function () {
                return [
                    {
                        display : this.$t('message.codigo'),
                        value : 'codigo'
                    },
                    {
                        display : this.$t('message.descripcion'),
                        value : 'descripcion'
                    },
                    {
                        display : this.$t('message.tipo'),
                        value : 'descripcion_tipo'
                    },
                    {
                        display : this.$t('message.creacion'),
                        value : 'created_at'
                    },
                    {
                        display : this.$t('message.modificacion'),
                        value : 'updated_at'
                    }
                ];
            }
        },
        damage : {
            type : String,
            required : false,
            default : 'Daño máquina'
        },
        reparation : {
            type : String,
            required : false,
            default : 'Daño caja'
        }
    },
    data : function () {
        return {
            selectedIndex : -1,
            selectedItem : null,
            tipoGuardado : 'N',
            url : url
        }
    },
    methods : {
        crear : function () {
            this.selectedIndex = -1;
            this.tipoGuardado = 'N';
            this.selectedItem = {
                id : '',
                codigo : '',
                descripcion : '',
                estado : 'N',
                tipo : 'D'
            };
            this.$modal.show('reparacion');
        },
        editar : function (row) {
            this.selectedIndex = this.$refs.listaReparaciones.rows.indexOf(row);
            this.tipoGuardado = 'E';
            this.selectedItem = {
                id : row.id,
                codigo : row.codigo,
                descripcion : row.descripcion,
                estado : row.estado,
                tipo : row.tipo
            };
            this.$modal.show('reparacion');
        },
        eliminar : function (row) {
            this.selectedIndex = this.$refs.listaReparaciones.rows.indexOf(row);
            this.selectedItem = row;
            let enabled = row.estado === 'A';
            let that = this;
            swal({
                title: (this.$t('message.deseas') + ' ' + (enabled?this.$t('message.desactivar'):this.$t('message.activar')) + ' ' + this.$t('message.esteRegistro') + ' ? '),
                text: this.$t('message.requiereConfirmacion'),
                type: 'question',
                showCancelButton: true,
                confirmButtonText: that.$t('message.confirmar'),
                cancelButtonText : that.$t('message.cancelar')
                }).then((result) => {
                    if (result.value) {
                        axios.post(that.url + '/reparaciones/' + row.id, {
                            _method : 'DELETE'
                        }).then(function (response) {
                            swal(that.$t('message.elRegistro') + ' ' + (enabled?that.$t('message.desactivado'):that.$t('message.activado')) + '.', that.$t('message.aviso'), 'success');
                            that.$refs.listaReparaciones.rows.splice(that.selectedIndex, 1);
                            that.selectedIndex = -1;
                            that.selectedItem = null;
                        });
                    }
                    else {
                        that.selectedIndex = -1;
                        that.selectedItem = null;
                    }
                });
        },
        cancelar : function () {
            this.selectedIndex = -1;
            this.selectedItem = null;
            this.$modal.hide('reparacion');
        },
        saved : function(row) {
            if (this.selectedIndex === -1)
                this.$refs.listaReparaciones.rows.unshift(row);
            else 
                this.$refs.listaReparaciones.rows.splice(this.selectedIndex, 1, row);
            this.selectedIndex = -1;
            this.selectedItem = -1;
            this.$modal.hide('reparacion');
        }
    }
}
</script>



// WEBPACK FOOTER //
// resources/assets/js/components/forms/reparaciones/ListaReparaciones.vue